/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { CustomerStatus } from './CustomerStatus';
import {
    CustomerStatusFromJSON,
    CustomerStatusFromJSONTyped,
    CustomerStatusToJSON,
} from './CustomerStatus';
import type { KokpitPackageNameListDto } from './KokpitPackageNameListDto';
import {
    KokpitPackageNameListDtoFromJSON,
    KokpitPackageNameListDtoFromJSONTyped,
    KokpitPackageNameListDtoToJSON,
} from './KokpitPackageNameListDto';

/**
 * 
 * @export
 * @interface CustomerDto
 */
export interface CustomerDto {
    /**
     * 
     * @type {number}
     * @memberof CustomerDto
     */
    tenantId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerDto
     */
    kokpitCustomerId?: number | null;
    /**
     * Kod
     * @type {string}
     * @memberof CustomerDto
     */
    code?: string | null;
    /**
     * İsim
     * @type {string}
     * @memberof CustomerDto
     */
    name?: string | null;
    /**
     * Blokeli
     * @type {boolean}
     * @memberof CustomerDto
     */
    isBlocked?: boolean | null;
    /**
     * İletişim İsmi
     * @type {string}
     * @memberof CustomerDto
     */
    contactName?: string | null;
    /**
     * Telefon No
     * @type {string}
     * @memberof CustomerDto
     */
    phone?: string | null;
    /**
     * Vergi İsmi
     * @type {string}
     * @memberof CustomerDto
     */
    taxName?: string | null;
    /**
     * Vergi Numarası
     * @type {string}
     * @memberof CustomerDto
     */
    taxNumber?: string | null;
    /**
     * Faks
     * @type {string}
     * @memberof CustomerDto
     */
    fax?: string | null;
    /**
     * E-posta
     * @type {string}
     * @memberof CustomerDto
     */
    email?: string | null;
    /**
     * Adres
     * @type {string}
     * @memberof CustomerDto
     */
    address?: string | null;
    /**
     * Şehir
     * @type {string}
     * @memberof CustomerDto
     */
    city?: string | null;
    /**
     * Ülke
     * @type {string}
     * @memberof CustomerDto
     */
    country?: string | null;
    /**
     * Borç
     * @type {number}
     * @memberof CustomerDto
     */
    debt?: number | null;
    /**
     * 
     * @type {CustomerStatus}
     * @memberof CustomerDto
     */
    status?: CustomerStatus;
    /**
     * Not
     * @type {string}
     * @memberof CustomerDto
     */
    note?: string | null;
    /**
     * 2. Email
     * @type {string}
     * @memberof CustomerDto
     */
    email2?: string | null;
    /**
     * Gsm No
     * @type {string}
     * @memberof CustomerDto
     */
    msisdn?: string | null;
    /**
     * Logo
     * @type {string}
     * @memberof CustomerDto
     */
    logo?: string | null;
    /**
     * Ortam Id
     * @type {number}
     * @memberof CustomerDto
     */
    kokpitEnvironmentId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerDto
     */
    isPrivate?: boolean;
    /**
     * Müşteri Kanalı Id
     * @type {number}
     * @memberof CustomerDto
     */
    customerChannelId?: number | null;
    /**
     * 
     * @type {Array<KokpitPackageNameListDto>}
     * @memberof CustomerDto
     */
    kokpitPackages?: Array<KokpitPackageNameListDto> | null;
}

/**
 * Check if a given object implements the CustomerDto interface.
 */
export function instanceOfCustomerDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CustomerDtoFromJSON(json: any): CustomerDto {
    return CustomerDtoFromJSONTyped(json, false);
}

export function CustomerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'kokpitCustomerId': !exists(json, 'kokpitCustomerId') ? undefined : json['kokpitCustomerId'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isBlocked': !exists(json, 'isBlocked') ? undefined : json['isBlocked'],
        'contactName': !exists(json, 'contactName') ? undefined : json['contactName'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'taxName': !exists(json, 'taxName') ? undefined : json['taxName'],
        'taxNumber': !exists(json, 'taxNumber') ? undefined : json['taxNumber'],
        'fax': !exists(json, 'fax') ? undefined : json['fax'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'debt': !exists(json, 'debt') ? undefined : json['debt'],
        'status': !exists(json, 'status') ? undefined : CustomerStatusFromJSON(json['status']),
        'note': !exists(json, 'note') ? undefined : json['note'],
        'email2': !exists(json, 'email2') ? undefined : json['email2'],
        'msisdn': !exists(json, 'msisdn') ? undefined : json['msisdn'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'kokpitEnvironmentId': !exists(json, 'kokpitEnvironmentId') ? undefined : json['kokpitEnvironmentId'],
        'isPrivate': !exists(json, 'isPrivate') ? undefined : json['isPrivate'],
        'customerChannelId': !exists(json, 'customerChannelId') ? undefined : json['customerChannelId'],
        'kokpitPackages': !exists(json, 'kokpitPackages') ? undefined : (json['kokpitPackages'] === null ? null : (json['kokpitPackages'] as Array<any>).map(KokpitPackageNameListDtoFromJSON)),
    };
}

export function CustomerDtoToJSON(value?: CustomerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenantId': value.tenantId,
        'kokpitCustomerId': value.kokpitCustomerId,
        'code': value.code,
        'name': value.name,
        'isBlocked': value.isBlocked,
        'contactName': value.contactName,
        'phone': value.phone,
        'taxName': value.taxName,
        'taxNumber': value.taxNumber,
        'fax': value.fax,
        'email': value.email,
        'address': value.address,
        'city': value.city,
        'country': value.country,
        'debt': value.debt,
        'status': CustomerStatusToJSON(value.status),
        'note': value.note,
        'email2': value.email2,
        'msisdn': value.msisdn,
        'logo': value.logo,
        'kokpitEnvironmentId': value.kokpitEnvironmentId,
        'isPrivate': value.isPrivate,
        'customerChannelId': value.customerChannelId,
        'kokpitPackages': value.kokpitPackages === undefined ? undefined : (value.kokpitPackages === null ? null : (value.kokpitPackages as Array<any>).map(KokpitPackageNameListDtoToJSON)),
    };
}

